import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmoothScroll from "@/lib/SmoothScroll";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import WatIsHumanDesign from "@/pages/WatIsHumanDesign";
import OverMarcel from "@/pages/OverMarcel";
import Aanbod from "@/pages/Aanbod";
import AanbodDetail from "@/pages/AanbodDetail";
import Methodes from "@/pages/Methodes";
import Boeken from "@/pages/Boeken";
import BetalingTerug from "@/pages/BetalingTerug";
import GratisQA from "@/pages/GratisQA";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import AlgemeneVoorwaarden from "@/pages/AlgemeneVoorwaarden";
import Disclaimer from "@/pages/Disclaimer";
import NotFound from "@/pages/NotFound";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <SmoothScroll>
                    <Layout>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route
                                path="/wat-is-human-design"
                                element={<WatIsHumanDesign />}
                            />
                            <Route path="/aanbod" element={<Aanbod />} />
                            <Route path="/aanbod/:slug" element={<AanbodDetail />} />
                            <Route path="/methodes" element={<Methodes />} />
                            <Route path="/boeken" element={<Boeken />} />
                            <Route path="/betaling/terug" element={<BetalingTerug />} />
                            <Route path="/admin" element={<Admin />} />
                            <Route path="/admin/verify" element={<Admin />} />
                            <Route path="/gratis-qa" element={<GratisQA />} />
                            <Route path="/blog" element={<Blog />} />
                            <Route path="/blog/:slug" element={<BlogPost />} />
                            <Route
                                path="/over-marcel"
                                element={<OverMarcel />}
                            />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/privacy" element={<Privacy />} />
                            <Route
                                path="/algemene-voorwaarden"
                                element={<AlgemeneVoorwaarden />}
                            />
                            <Route
                                path="/disclaimer"
                                element={<Disclaimer />}
                            />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </Layout>
                </SmoothScroll>
            </BrowserRouter>
        </div>
    );
}

export default App;
